import { Icon } from '@arco-design/web-vue'
import SvgIcon from '@fe/zxwy-utils/components/v-svg-icon'
import Avatar from '@fe/zxwy-utils/components/v3-arco-avatar'
import PopSelector, { PopFormTagInput } from '@fe/zxwy-utils/components/v3-arco-pop-selector'

const requireContext = require.context('@/assets/svg', false, /\.svg$/)

requireContext.keys().map(requireContext)

import WujieVue from './WujieVue/index.vue'

import request from '@/tool/request'

export default {
  install(app) {
    app.component(WujieVue.name, WujieVue)
    Icon.addFromIconFontCn({ src: '//at.alicdn.com/t/c/font_4544585_vpw4ukmmxbe.js' })
    // zxwy-color-icon
    Icon.addFromIconFontCn({ src: '//at.alicdn.com/t/c/font_4857886_wrc6rb3kdj.js' })
    // zxwy-color-icon
    Icon.addFromIconFontCn({ src: '//at.alicdn.com/t/c/font_4953192_ipcpfg7xkua.js' })
    // zxwy-fill-icon
    app.component('IconFont', Icon.addFromIconFontCn({ src: '//at.alicdn.com/t/c/font_4508458_4gcrfz9o6s.js' }))
    Icon.addFromIconFontCn({ src: '//at.alicdn.com/t/c/font_4508458_ychfzbz9wa9.js' })
    // remixicon
    app.component('SvgIcon', SvgIcon.addRemixIcon('https://cdn.zxwy123.com/remixicon@4.2.0/fonts/remixicon.symbol.svg'))
    Icon.addFromIconFontCn({ src: '//at.alicdn.com/t/c/font_4508458_kckmod1uhqk.js' })
    Icon.addFromIconFontCn({
      src: '//at.alicdn.com/t/c/font_4564291_huh3dlf6xcw.js'
    })
    // 头像
    app.component(Avatar.name, Avatar)
    // 标签表单输入框
    app.component(PopFormTagInput.name, PopFormTagInput)
    // 弹框选择器
    PopSelector.use({ request })
    app.component(PopSelector.name, PopSelector)
    app.config.globalProperties.$PopSelector = PopSelector
  }
}
